<template>
    <card-list-item>
        <template v-slot:icon>
            <i class="far fa-file-invoice-dollar fa-fw"></i>
        </template>
        <template v-slot:content>
            <section>
                <div class="tile-title">{{ transaction.transaction_type }}</div>
                <div class="meta" v-if="transaction.description">
                    <i class="fas fa-align-left mr-2 fa-fw"></i>{{ transaction.description }}
                </div>
                <div class="meta">
                    <i class="fas fa-calendar mr-2 fa-fw"></i>{{ transaction.date | moment('MMM D, YYYY') }}
                </div>
                <div class="meta" v-if="transaction.user_name">
                    <i class="fas fa-user mr-2 fa-fw"></i>{{ transaction.user_name }}
                </div>
            </section>
        </template>
        <template v-slot:status>
            <div class="amount-display">
                <div class="total-amount">{{ formatCurrency(transaction.tax_amount) }}</div>
                <div class="tax-detail">{{ formatCurrency(transaction.base_amount) }} ({{ formatPercent(transaction.tax_rate) }})</div>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="Transaction Type">{{ transaction.transaction_type }}</data-row>
                    <data-row mini title="Transaction ID">{{ transaction.transaction_id }}</data-row>
                    <data-row mini title="Description" v-if="transaction.description">{{ transaction.description }}</data-row>
                    <data-row mini title="Date">{{ transaction.date | moment('MMMM Do YYYY, h:mm a') }}</data-row>
                    <data-row mini title="User" v-if="transaction.user_name">{{ transaction.user_name }}</data-row>
                    <data-row mini title="Email" v-if="transaction.user_email">{{ transaction.user_email }}</data-row>
                    <data-row mini title="Base Amount">{{ formatCurrency(transaction.base_amount) }}</data-row>
                    <data-row mini title="Tax Amount">{{ formatCurrency(transaction.tax_amount) }}</data-row>
                    <data-row mini title="Total Amount">{{ formatCurrency(transaction.total_amount) }}</data-row>
                    <data-row mini title="Tax Rate">{{ formatPercent(transaction.tax_rate) }}</data-row>
                    <data-row mini title="State Rate">{{ formatPercent(transaction.tax_state_rate) }}</data-row>
                    <data-row mini title="Local Rate">{{ formatPercent(transaction.tax_local_rate) }}</data-row>
                    <data-row mini title="Jurisdiction">{{ transaction.tax_jurisdiction || 'N/A' }}</data-row>
                    <data-row mini title="Location Code">{{ transaction.tax_location_code || 'N/A' }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import numeral from "numeral";

    export default {
        name: 'SalesTaxTransactionTile',
        components: {CardListItem, DataRow},
        props: {
            transaction: {
                type: Object,
                required: true
            }
        },
        methods: {
            formatCurrency(value) {
                return numeral(value).format('$0,0.00');
            },
            formatPercent(value) {
                return numeral(value * 100).format('0.000') + '%';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .amount-display {
        text-align: right;

        .total-amount {
            font-size: 0.9rem;
            font-weight: bold;
            color: #363636;
        }

        .tax-detail {
            font-size: 0.8rem;
            color: #7a7a7a;
            margin-top: 0.25rem;
        }
    }
</style>
